import _styled from "styled-components";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { basicStyle } from './IframeWrapper.style';
export const IframeWrapper = _ref => {
  let {
    src,
    width = '640px',
    height = '480px',
    title,
    fit = false,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(_StyledIframe, _extends({
    title: title,
    $fit: fit,
    frameBorder: "0",
    allowFullScreen: true,
    width: width,
    height: height,
    src: src
  }, rest));
};
export default IframeWrapper;
var _StyledIframe = _styled("iframe").withConfig({
  displayName: "IframeWrapper___StyledIframe",
  componentId: "sc-18ma46g-0"
})(["", ""], basicStyle);
//# sourceMappingURL=IframeWrapper.js.map